export { default } from './P12HalfTextHalfImage';
